import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/conflict/";

const ConflictBeoordelingApi = {
	get(gpxConflictId) {
		const listByUrl = prependRoot(routePrefix + "/" + gpxConflictId, getApiRoot());
		return axios.get(listByUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getLussenMetConflict(tochtId) {
		const url = prependRoot(routePrefix + "lussenMetConflict/" + tochtId, getApiRoot());
		return axios.get(url, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	beoordeelConflict(gpxConflictId, isConflict) {
		const serviceUrl = prependRoot(routePrefix + "beoordeel", getApiRoot());
		return axios.post(serviceUrl,
			{
				gpxConflictId: gpxConflictId,
				isConflict: isConflict
			},
			{
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default ConflictBeoordelingApi;
